export default __webpack_public_path__ + "static/media/thesis.347b86a6.png";